export function navigation() {
	function toggleMenu() {
		var body = document.querySelector('body')
		var nav__button = document.querySelector('.nav__menu')

		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			nav__button.classList.remove('is-active')
		} else {
			body.classList.add('js-nav-open')
			nav__button.classList.add('is-active')
		}
	}

	document.querySelectorAll('.js-nav__menu').forEach((item) => item.addEventListener('click', toggleMenu))
	document.querySelectorAll('.nav__site li:not(.has-children):not(.eco--bereiche):not(.eco--branchen)').forEach((item) => item.addEventListener('click', toggleMenu))

	initMegamenu()

	// hide header on scroll down ==========================================
	var didScroll
	var lastScrollTop = 0
	var delta = 20

	document.addEventListener('scroll', function () {
		didScroll = true
	})

	document.querySelector('.site__header').classList.add('nav-down')

	setInterval(function () {
		if (didScroll) {
			if (!document.querySelector('.nav__menu').classList.contains('is-active') && !document.body.classList.contains('js-megamenu-open')) {
				hasScrolled()
			}
			didScroll = false
		}
	}, 250)

	function hasScrolled() {
		var st = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return

		// If they scrolled down and are past 50vh, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > window.innerHeight / 2) {
			// Scroll Down
			document.querySelector('.site__header').classList.remove('nav-down')
			document.querySelector('.site__header').classList.add('nav-up')
		} else {
			// Scroll Up
			document.querySelector('.site__header').classList.remove('nav-up')
			document.querySelector('.site__header').classList.add('nav-down')
		}

		lastScrollTop = st
	}

	// ESC: Navigation und Megamenu schließen
	document.addEventListener('keydown', function(event) {
		if (event.key !== 'Escape') return

		const body = document.querySelector('body')
		const nav__button = document.querySelector('.nav__menu')

		if (body.classList.contains('js-megamenu-open')) return

		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			nav__button.classList.remove('is-active')
		}
	})
}

const MEGAMENU_IDS = ['eco--bereiche', 'eco--branchen']

function initMegamenu() {
	const body = document.body
	if (!body.classList.contains('site--listeco')) return

	const getPanel = (id) => document.querySelector(`.megamenu[data-megamenu="${id}"]`)
	const panels = MEGAMENU_IDS.map(getPanel).filter(Boolean)

	if (!panels.length) return

	const triggerSelector = MEGAMENU_IDS.map((id) => `#${id}:not(.megamenu), .${id}:not(.megamenu), [href="#${id}"]`).join(', ')

	const getTriggers = (id) => document.querySelectorAll(`#${id}:not(.megamenu), .${id}:not(.megamenu), [href="#${id}"]`)

	const getMegamenuId = (el) => MEGAMENU_IDS.find((id) => el.matches(`#${id}, .${id}, [href="#${id}"]`))

	const closeMobileNav = () => {
		body.classList.remove('js-nav-open')
		document.querySelector('.nav__menu')?.classList.remove('is-active')
	}

	const closeAll = () => {
		panels.forEach((panel) => {
			const id = panel.dataset.megamenu
			panel.classList.remove('is-open')
			panel.setAttribute('aria-hidden', 'true')
			getTriggers(id).forEach((trigger) => {
				trigger.classList.remove('is-active')
				trigger.setAttribute('aria-expanded', 'false')
			})
		})
		body.classList.remove('js-megamenu-open')
	}

	const open = (id) => {
		const panel = getPanel(id)
		if (!panel) return

		closeMobileNav()
		closeAll()

		panel.classList.add('is-open')
		panel.setAttribute('aria-hidden', 'false')
		getTriggers(id).forEach((trigger) => {
			trigger.classList.add('is-active')
			trigger.setAttribute('aria-expanded', 'true')
		})
		body.classList.add('js-megamenu-open')
	}

	const toggle = (id) => {
		const panel = getPanel(id)
		if (!panel) return
		panel.classList.contains('is-open') ? closeAll() : open(id)
	}

	MEGAMENU_IDS.forEach((id) => {
		getTriggers(id).forEach((trigger) => {
			trigger.setAttribute('aria-expanded', 'false')
			trigger.setAttribute('aria-controls', id)
		})
	})

	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-nav__menu')) {
			closeAll()
			return
		}

		const closeBtn = e.target.closest('.megamenu__close')
		if (closeBtn) {
			e.preventDefault()
			closeAll()
			return
		}

		const trigger = e.target.closest(triggerSelector)
		if (trigger && !trigger.closest('.megamenu')) {
			e.preventDefault()
			const id = getMegamenuId(trigger)
			if (id) toggle(id)
			return
		}

		const openPanel = e.target.closest('.megamenu.is-open')
		if (openPanel && !e.target.closest('a, button')) {
			closeAll()
		}
	})

	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape' || !body.classList.contains('js-megamenu-open')) return

		e.preventDefault()
		closeAll()
	})
}
